import { type FC } from "react";
import { FormItemName } from "@root/shared/components/FormItemName";
import { InformationText } from "@root/shared/components/InformationText";
import { TextField } from "@root/shared/components/TextField";
import { StepCassette } from "../StepCassette";
import * as styles from "./style.css";
import { headingEmphasis } from "../../styles.css";

type Props = {
  value?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessage?: string;
};

export const Presentation: FC<Props> = ({ value, onChange, errorMessage }) => {
  return (
    <StepCassette
      heading={
        <>
          1ヶ月あたり
          <br />
          <span className={headingEmphasis}>個人売上</span>はどのくらいですか？
        </>
      }
    >
      <FormItemName labelRequirementType="required">平均個人売上（月）</FormItemName>
      <div className={styles.textFieldWrapper}>
        <TextField
          name="personalSales"
          value={value}
          onChange={onChange}
          hasError={!!errorMessage}
          inputMode="numeric"
          placeholder="半角数字で入力してください"
        />
        円
      </div>
      {errorMessage && (
        <InformationText isAlert text={errorMessage} className={styles.errorMessage} />
      )}
    </StepCassette>
  );
};
